import { Component, OnInit, Input,  ChangeDetectorRef } from '@angular/core';
import { InstallationStatus } from '@shared-features/enums/fleets.enum';
import { Observable, Subject, Subscription } from 'rxjs';
import { BaseComponent } from '@shared-features/components/base-component/base.component';
import { FilterService } from '../../../filter/services/filter.service';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import {  TabGroup, TabIndex } from '@shared-features/enums/tab.enum';
import { FormAction } from '@shared-features/enums/shared-enums.enum';
import { FilterAction } from '@shared-features/models/filter-action.model';
import { FormControl, FormGroup } from '@angular/forms';
import { ConfigConstant } from '@shared/constants';

@Component({
  selector: 'app-drivers-filter',
  templateUrl: './drivers-filter.component.html',
  styleUrls: ['./drivers-filter.component.scss'],
})
export class DriversFilterComponent extends BaseComponent implements OnInit {
  @Input() action: Observable<FilterAction>;
  installationStatus = InstallationStatus;
  sharedConstants = ConfigConstant;
  form: FormGroup;
  filterActionSubscription: Subscription;
  params: any = null;
  dispose$ = new Subject();
  @Input() tabGroup: TabGroup;
  @Input() tabIndex: TabIndex;
  currentTabIndex = 0;
  constructor(
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private ref: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscribeToQueryParams();
    this.subscribeToFilterAction();
    this.subscribeToCurrentTabIndex();
    this.initForm();
  }

  ngOnDestroy() {
    this.filterActionSubscription.unsubscribe();
    super.ngOnDestroy();
  }

  ngAfterContentChecked() {
    this.ref.detectChanges();
  }

  subscribeToQueryParams(): void {
    this.activatedRoute.queryParams.pipe(takeUntil(this.dispose$)).subscribe((params) => {
      if (params && Object.keys(params).length !== 0) {
        this.params = params;
      }
    });
  }

  subscribeToFilterAction() {
    this.filterActionSubscription = this.action.subscribe((action: any) => {
      switch (action) {
        case FormAction.Reset:
          this.resetForm();
          break;

        case FormAction.Cancel:
          this.cancelChanges();
          break;

        case FormAction.Submit:
          this.submitForm();
          break;
      }
    });
  }

  subscribeToCurrentTabIndex() {
    this.filterService.currentTabIndex$.pipe(takeUntil(this.destroy$)).subscribe((index) => {
      this.currentTabIndex = index;
    });
  }

  getFilterValuesBasedOnURLParams() {
    return {
      appDownloadedFilter:
        this.params.appDownloadedFilter === InstallationStatus.Downloaded
          ? InstallationStatus.Downloaded
          : String(this.params.appDownloadedFilter),
    };
  }

  initForm() {
    if (this.params && Object.keys(this.params).length !== 0) {
      this.form = new FormGroup({
        appDownloadedFilter: new FormControl(this.params.appDownloadedFilter ? this.params.appDownloadedFilter : ConfigConstant.ALL),
      });
    } else {
      this.form = new FormGroup({
        appDownloadedFilter: new FormControl(ConfigConstant.ALL),
      });
    }
  }

  cancelChanges() {
    if (this.params && Object.keys(this.params).length !== 0) {
      const filterValues = this.getFilterValuesBasedOnURLParams();
      this.form?.controls['appDownloadedFilter']?.setValue(filterValues.appDownloadedFilter);
    } else {
      this.resetForm();
    }
  }

  resetForm() {
    this.form?.controls['appDownloadedFilter']?.setValue(ConfigConstant.ALL);
    for (const property in this.form?.value) {
      if (property !== 'tabIndex' && property !== 'tabGroup' && property !== 'appDownloadedFilter') {
        this.form?.controls[property]?.setValue(ConfigConstant.ALL);
      }
      this.submitForm();
    }
  }

  submitForm() {
    const obj = this.form?.value;
    obj.tabIndex = this.tabIndex;
    obj.tabGroup = this.tabGroup;
    this.filterService.navigateToTargetPageWithFilter(obj);
  }
}
